import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from 'axios';
// import "bootstrap/dist/css/bootstrap.min.css";
// import "./Worklogs.css";
import "./EmployeeProjectsPage.css";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import EmployeeNavbar from "../Layout/EmployeeNavbar";
import API_BASE_URL from "../config";

const EmployeeProjectsPage = () => {
    // const [isFullscreen, setIsFullscreen] = useState(false);
    // const [editingStatus, setEditingStatus] = useState(false);
    // const [worklogsCollapsed, setWorklogsCollapsed] = useState(false);


    const [employees, setEmployees] = useState([]);
    const [tasks, setTasks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeTask, setActiveTask] = useState(null);
    const [mentions, setMentions] = useState([]);
    const [mentionableUsers, setMentionableUsers] = useState([]);
    const [attachments, setAttachments] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [comments, setComments] = useState([]);
    const [editingCommentId, setEditingCommentId] = useState(null);
    const [editContent, setEditContent] = useState("");
    const [replies, setReplies] = useState([]); // store replies for comments
    const [replyToCommentId, setReplyToCommentId] = useState(null); // which comment is being replied to
    const [replyContent, setReplyContent] = useState(""); // content of the reply
    const [worklogs, setWorklogs] = useState([]);
    const [showLogForm, setShowLogForm] = useState(false);
    const [logDescription, setLogDescription] = useState("");
    const [logHours, setLogHours] = useState("");
    const [logDate, setLogDate] = useState(new Date().toISOString().split("T")[0]);
    const [billingType, setBillingType] = useState("billable");
    const [logAnother, setLogAnother] = useState(false);
    const [editWorklogId, setEditWorklogId] = useState(null);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [searchQuery, setSearchQuery] = useState("");
    const [filterType, setFilterType] = useState("all");
    const [selectedProject, setSelectedProject] = useState("all"); // "all" or project ID as string
    const [projects, setProjects] = useState([]);
    const [savedRange, setSavedRange] = useState(null);

    // Create Task modal states
    const [showCreateTask, setShowCreateTask] = useState(false);
    const [newTaskTitle, setNewTaskTitle] = useState("");
    const [newTaskDescription, setNewTaskDescription] = useState("");
    const [newTaskProject, setNewTaskProject] = useState("");
    const [newTaskAssignee, setNewTaskAssignee] = useState("");
    const [newTaskReporter, setNewTaskReporter] = useState("");
    const [newTaskDueDate, setNewTaskDueDate] = useState("");
    const [newTaskPriority, setNewTaskPriority] = useState("Medium");
    const [newTaskType, setNewTaskType] = useState("Feature");
    const [newTaskEstimatedTime, setNewTaskEstimatedTime] = useState("");
    const [newTaskTotalTime, setNewTaskTotalTime] = useState("");
    const [newTaskTeam, setNewTaskTeam] = useState("");
    const [teams, setTeams] = useState([]);
    const [editField, setEditField] = useState(null);
    const [editedTask, setEditedTask] = useState(activeTask);
    const [taskAttachments, setTaskAttachments] = useState([]);
    const [previewImages, setPreviewImages] = useState([]);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [projectEmployees, setProjectEmployees] = useState([]);
    const [collapsedProjects, setCollapsedProjects] = useState({});






    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const logsPerPage = 3;

    const editorRef = useRef(null);
    const editRef = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();

    const token = localStorage.getItem("token");
    const employeeId =
        location.state?.employeeId || localStorage.getItem("employeeId");

    const moveCaretToEnd = (el) => {
        if (!el) return;
        const range = document.createRange();
        range.selectNodeContents(el);
        range.collapse(false);
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
    };

    const saveCaret = () => {
        const sel = window.getSelection();
        if (sel && sel.rangeCount > 0) {
            setSavedRange(sel.getRangeAt(0));
        }
    };

    const handleFieldClick = (field) => {
        setEditField(field);
    };

    const handleFieldChange = (field, value) => {
        setEditedTask({ ...editedTask, [field]: value });
    };

    const handleBlur = () => {
        // Save or update backend here if needed
        setEditField(null);
    };


    {/* Helper to check if base64 has data: prefix */ }
    const getDataUrl = (file) => {
        if (!file.base64) return "";
        return file.base64.startsWith("data:")
            ? file.base64
            : `data:${getMimeType(file.name)};base64,${file.base64}`;
    };

    /* Helper to get MIME type from file name */
    const getMimeType = (filename) => {
        const ext = filename?.split(".").pop()?.toLowerCase();
        switch (ext) {
            case "jpg":
            case "jpeg":
                return "image/jpeg";
            case "png":
                return "image/png";
            case "gif":
                return "image/gif";
            case "bmp":
                return "image/bmp";
            case "webp":
                return "image/webp";
            default:
                return "application/octet-stream";
        }
    };


    const toggleProjectCollapse = (projectKey) => {
        setCollapsedProjects((prev) => ({ ...prev, [projectKey]: !prev[projectKey] }));
    };


    // 🔐 Authentication check
    useEffect(() => {
        const token = localStorage.getItem("token"); // or localStorage
        if (!token) {
            toast.error("You must be logged in to access this page.");
            navigate("/");
        }
    }, [navigate]);


    useEffect(() => {
        // If no project selected, clear dropdown options
        if (!newTaskProject) {
            setProjectEmployees([]);
            setNewTaskAssignee("");
            setNewTaskReporter("");
            return;
        }

        const fetchProjectEmployees = async () => {
            try {
                const res = await fetch(
                    `${API_BASE_URL}/api/manageteam/project/${newTaskProject}/employees`
                );
                if (!res.ok) {
                    console.error("Failed to load project employees");
                    setProjectEmployees([]);
                    return;
                }
                const data = await res.json();
                setProjectEmployees(data);

                // Reset selections if they are not in this project anymore
                setNewTaskAssignee("");
                setNewTaskReporter("");
            } catch (err) {
                console.error("Error fetching project employees", err);
                setProjectEmployees([]);
            }
        };

        fetchProjectEmployees();
    }, [newTaskProject]);


    const updateTaskField = async (taskId, field, value) => {
        try {
            const formData = new FormData();

            // 🟢 MANDATORY FIELDS (always required)
            formData.append("title", activeTask.title || "");
            formData.append("description", activeTask.description || "");
            formData.append(
                "dueDate",
                activeTask.dueDate
                    ? new Date(activeTask.dueDate).toISOString().split("T")[0]
                    : ""
            );
            formData.append("employeeId", activeTask.assignedTo?.id || "");
            formData.append("projectId", activeTask.project?.id || "");

            // 🟡 OPTIONAL FIELDS
            formData.append("priority", activeTask.priority || "");
            formData.append("taskType", activeTask.taskType || "");
            formData.append("teamId", activeTask.team?.id || "");
            formData.append("estimatedTime", activeTask.estimatedTime || "");
            formData.append("totalTime", activeTask.totalTime || "");
            formData.append("reporterId", activeTask.reporter?.id || "");
            formData.append("status", activeTask.status || "");

            // 🔹 OVERRIDE the single field being edited (ensure new value takes priority)
            if (value !== undefined && field) {
                formData.set(field, value);
            }

            // 🧠 Log for debugging
            console.log(
                `Updating field '${field}' with value:`,
                value,
                "→ sending full task data to backend..."
            );

            const response = await axios.put(
        `${API_BASE_URL}/api/tasks/${taskId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

            // ✅ Update local task data
            setActiveTask(response.data);
            console.log("✅ Task updated successfully:", response.data);
        } catch (error) {
            console.error("❌ Failed to update task:", error);
        }
    };



    useEffect(() => {
        if (!activeTask?.id) return;

        const fetchAttachments = async () => {
            try {
                const res = await fetch(
                    `${API_BASE_URL}/api/tasks/${activeTask.id}/comment-attachments`,
                    {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    }
                );

                if (res.ok) {
                    const data = await res.json();
                    setTaskAttachments(data);
                } else {
                    console.error("Failed to fetch attachments:", res.status);
                }
            } catch (err) {
                console.error("Error fetching attachments:", err);
            }
        };

        fetchAttachments();
    }, [activeTask]);



    useEffect(() => {
        if (!token) navigate("/");
    }, [token, navigate]);

    useEffect(() => {
        if (!employeeId || !token) {
            setLoading(false);
            return;
        }
        fetch(`${API_BASE_URL}/api/tasks/projects-of-employee/${employeeId}`, {
            headers: { Authorization: "Bearer " + token },
        })
            .then((res) => res.json())
            .then((data) => {
                setTasks(Array.isArray(data) ? data : []);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [employeeId, token]);

    useEffect(() => {
        if (!employeeId || !token) return;
        fetch(
            `${API_BASE_URL}/api/tasks/mentionable-users?employeeId=${employeeId}`,
            { headers: { Authorization: "Bearer " + token } }
        )
            .then((res) => res.json())
            .then((data) => setMentionableUsers(data))
            .catch(() => setMentionableUsers([]));
    }, [employeeId, token]);

    useEffect(() => {
        const fetchProjects = async () => {
            try {
                const token = localStorage.getItem("token");
                const employeeId = localStorage.getItem("employeeId"); // or wherever you store it

                if (!employeeId) {
                    console.error("Employee ID missing");
                    return;
                }

                const res = await fetch(
                    `${API_BASE_URL}/api/manageteam/employee/${employeeId}/projects`,
                    {
                        headers: { Authorization: "Bearer " + token }
                    }
                );

                if (!res.ok) throw new Error("Failed to fetch employee projects");

                const data = await res.json();
                setProjects(Array.isArray(data) ? data : []);
            } catch (err) {
                console.error("Error loading projects:", err);
                setProjects([]);
            }
        };

        fetchProjects();
    }, []);


    // Auto-open task when URL contains the task id.
// Supports:
// 1) path:      /empprojtask/:taskId      <- used by your other page
// 2) query:     ?taskId=123
// 3) location.state: { taskId: 123 }
useEffect(() => {
  // Try path /empprojtask/:id first
  const pathMatch = location.pathname.match(/\/empprojtask\/([^\/?#]+)/i);
  let urlTaskId = pathMatch ? pathMatch[1] : null;

  // Fallback: querystring ?taskId=...
  if (!urlTaskId) {
    const params = new URLSearchParams(location.search);
    urlTaskId = params.get("taskId");
  }

  // Fallback: location.state
  if (!urlTaskId && location.state && location.state.taskId) {
    urlTaskId = String(location.state.taskId);
  }

  if (!urlTaskId) return;

  const token = localStorage.getItem("token");

  const fetchTaskById = async (id) => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/tasks/${id}`, {
        headers: token ? { Authorization: "Bearer " + token } : {},
      });
      if (!res.ok) {
        console.error("Failed to fetch task:", res.status, await res.text());
        return;
      }
      const data = await res.json();

      // set active task and perform the same follow-ups as openTask
      setActiveTask(data);

      // fetch comments
      try {
        const cRes = await fetch(`${API_BASE_URL}/api/tasks/${id}/comments`, {
          headers: token ? { Authorization: "Bearer " + token } : {},
        });
        const cData = cRes.ok ? await cRes.json() : [];
        setComments(cData);
      } catch (err) {
        console.error("Failed to fetch comments:", err);
        setComments([]);
      }

      // fetch worklogs (use existing helper; it can accept id)
      if (typeof fetchWorklogs === "function") {
        fetchWorklogs(id);
      } else {
        // fallback: call existing logic that relies on activeTask
        // (no-op here if not available)
      }

      // reset editors / attachments / editing states to match openTask behavior
      if (editorRef?.current) editorRef.current.innerHTML = "";
      if (editRef?.current) editRef.current.innerHTML = "";
      setMentions([]);
      setAttachments([]);
      setEditingCommentId(null);
      setEditContent("");

      // optional: if you want to clean URL so reload won't re-open
      // navigate(location.pathname, { replace: true });

    } catch (err) {
      console.error("Error fetching task by id:", err);
    }
  };

  fetchTaskById(urlTaskId);
  // re-run if location changes
}, [location.pathname, location.search, location.state]);


    useEffect(() => {
  const fetchEmployees = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/employees/active`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`, 
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch employees");
      }

      const data = await response.json();
      setEmployees(data);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  fetchEmployees();
}, [token]); 



    // --- AUTO-OPEN TASK FROM URL: add below your openTask / fetchWorklogs functions ---
useEffect(() => {
  // Try to get taskId from querystring: ?taskId=123
  const params = new URLSearchParams(location.search);
  let urlTaskId = params.get("taskId");

  // If not in querystring, try path param pattern: /tasks/123 (optional)
  // e.g., location.pathname === "/tasks/123"
  if (!urlTaskId) {
    const pathMatch = location.pathname.match(/\/tasks\/(\d+)/);
    if (pathMatch) urlTaskId = pathMatch[1];
  }

  // Also support location.state.taskId if another page navigated with state
  if (!urlTaskId && location.state && location.state.taskId) {
    urlTaskId = String(location.state.taskId);
  }

  if (!urlTaskId) return;

  // Fetch the task and open it
  const token = localStorage.getItem("token");
  const fetchTaskById = async (id) => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/tasks/${id}`, {
        headers: token ? { Authorization: "Bearer " + token } : {},
      });
      if (!res.ok) {
        console.error("Failed to fetch task:", res.status);
        return;
      }
      const data = await res.json();

      // set active task and run the same follow-up fetches as openTask
      setActiveTask(data);

      // fetch comments (same as openTask)
      try {
        const cRes = await fetch(`${API_BASE_URL}/api/tasks/${id}/comments`, {
          headers: token ? { Authorization: "Bearer " + token } : {},
        });
        const cData = cRes.ok ? await cRes.json() : [];
        setComments(cData);
      } catch (err) {
        console.error("Failed to fetch comments for task:", err);
        setComments([]);
      }

      // fetch attachments for task (if you rely on that effect, it's already watching activeTask;
      // to be safe, we can call fetchWorklogs below which uses activeTask id)
      fetchWorklogs(id);

      // prepare editor / UI similar to openTask
      if (editorRef.current) editorRef.current.innerHTML = "";
      setMentions([]);
      setAttachments([]);
      setEditingCommentId(null);
      setEditContent("");
      if (editRef.current) editRef.current.innerHTML = "";

      // optionally scroll to the task details panel or focus
      // document.querySelector('.inline-task-details')?.scrollIntoView({ behavior: 'smooth' });
    } catch (err) {
      console.error("Error fetching task by id:", err);
    }
  };

  fetchTaskById(urlTaskId);
  // run once when location changes (so if link with ?taskId changes, it will re-run)
}, [location.search, location.pathname, location.state]);


    useEffect(() => {
        // Need an active task AND its project
        if (!activeTask || !activeTask.project || !activeTask.project.id) {
            setMentionableUsers([]);
            return;
        }

        const projectId = activeTask.project.id;

        const fetchMentionableUsers = async () => {
            try {
                const response = await fetch(
                    `${API_BASE_URL}/api/manageteam/project/${projectId}/employees`
                );

                if (response.ok) {
                    const data = await response.json();
                    setMentionableUsers(Array.isArray(data) ? data : []);
                } else {
                    console.error("Failed to fetch project employees for mentions");
                    setMentionableUsers([]);
                }
            } catch (error) {
                console.error("Error fetching mention users:", error);
                setMentionableUsers([]);
            }
        };

        fetchMentionableUsers();
    }, [activeTask]);


    useEffect(() => {
  const token = localStorage.getItem("token");

  axios.get(
    `${API_BASE_URL}/api/teams`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
    .then((res) => setTeams(res.data))
    .catch((err) => console.error("Error fetching teams:", err));
}, []);



    // ✅ Load bootstrap CSS dynamically
    useEffect(() => {
        const bootstrapLink = document.createElement("link");
        bootstrapLink.rel = "stylesheet";
        bootstrapLink.href =
            "https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css";
        document.head.appendChild(bootstrapLink);

        const iconsLink = document.createElement("link");
        iconsLink.rel = "stylesheet";
        iconsLink.href =
            "https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css";
        document.head.appendChild(iconsLink);

        return () => {
            bootstrapLink.remove();
            iconsLink.remove();
        };
    }, []);



    // Call when opening a task
    const openTask = (task) => {
        setActiveTask(task);
        fetch(`${API_BASE_URL}/api/tasks/${task.id}/comments`, {
            headers: { Authorization: "Bearer " + token },
        })
            .then((res) => res.json())
            .then((data) => setComments(data))
            .catch(() => setComments([]));

        fetchWorklogs(task.id); // fetch worklogs here
        if (editorRef.current) editorRef.current.innerHTML = "";
        setMentions([]);
        setAttachments([]);
        setEditingCommentId(null);
        setEditContent("");
        if (editRef.current) editRef.current.innerHTML = "";
    };

    const updateTaskStatus = async (taskId, newStatus) => {
        const res = await fetch(
            `${API_BASE_URL}/api/tasks/${taskId}/status?employeeId=${employeeId}&status=${newStatus}`,
            {
                method: "PUT",
                headers: { Authorization: "Bearer " + token },
            }
        );
        if (res.ok) {
            setTasks((prev) =>
                prev.map((t) =>
                    t.id === taskId ? { ...t, status: newStatus } : t
                )
            );
            if (activeTask?.id === taskId) {
                setActiveTask({ ...activeTask, status: newStatus });
            }
        }
    };

    const getStatusBadge = (status) => {
        switch (status) {
            case "PENDING":
                return "bg-secondary";
            case "IN_PROGRESS":
                return "bg-primary";
            case "REVIEW":
                return "bg-warning text-dark";
            case "COMPLETED":
                return "bg-success";
            default:
                return "bg-info";
        }
    };





    // Fetch worklogs for active task
    const fetchWorklogs = (taskId) => {
        fetch(`${API_BASE_URL}/api/worklogs/employee/${employeeId}/task/${taskId}`, {
            headers: { Authorization: "Bearer " + token },
        })
            .then((res) => res.json())
            .then((data) => setWorklogs(data))
            .catch(() => setWorklogs([]));
    };

    // Save a new worklog
    const saveWorklog = async () => {
        if (!logDescription.trim() || !logHours) return;

        const payload = {
            employeeId: employeeId,
            taskId: activeTask.id,
            description: logDescription,
            hours: logHours,
            billingType: billingType,
            date: logDate,
            taskCode: activeTask.taskCode,

        };

        try {
            let res;
            if (editWorklogId) {
                // Edit existing
                res = await fetch(`${API_BASE_URL}/api/worklogs/${editWorklogId}`, {
                    method: "PUT",
                    headers: {
                        Authorization: "Bearer " + token,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                });
            } else {
                // Add new
                res = await fetch(`${API_BASE_URL}/api/worklogs`, {
                    method: "POST",
                    headers: {
                        Authorization: "Bearer " + token,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                });
            }

            if (res.ok) {
                const updatedLog = await res.json();
                setWorklogs((prev) => {
                    if (editWorklogId) {
                        return prev.map((w) => (w.id === editWorklogId ? updatedLog : w));
                    } else {
                        return [...prev, updatedLog];
                    }
                });

                // Reset form
                setEditWorklogId(null);
                setLogDescription("");
                setLogHours("");
                setBillingType("billable");
                setLogDate(new Date().toISOString().split("T")[0]);
                if (!logAnother) setShowLogForm(false);
            }
        } catch (err) {
            console.error("Error saving worklog:", err);
        }
    };


    const editWorklog = (log) => {
        setShowLogForm(true);
        setEditWorklogId(log.id);
        setLogDescription(log.description);
        setLogHours(log.hours);
        setBillingType(log.billingType);
        setLogDate(log.date.split("T")[0]); // format YYYY-MM-DD
    };

    const deleteWorklog = async (worklogId) => {
        if (!window.confirm("Are you sure you want to delete this worklog?")) return;
        try {
            const res = await fetch(`${API_BASE_URL}/api/worklogs/${worklogId}`, {
                method: "DELETE",
                headers: { Authorization: "Bearer " + token },
            });
            if (res.ok) {
                setWorklogs((prev) => prev.filter((w) => w.id !== worklogId));
            } else {
                console.error("Failed to delete worklog");
            }
        } catch (err) {
            console.error("Error deleting worklog:", err);
        }
    };

    const filteredLogs = worklogs.filter(log => {
        if (filterType === "date") {
            if (!fromDate || !toDate) return false;
            const logDate = new Date(log.date);
            const start = new Date(fromDate);
            const end = new Date(toDate);
            return logDate >= start && logDate <= end;
        }
        return true;
    });

    // ✅ Pagination logic
    const indexOfLastLog = currentPage * logsPerPage;
    const indexOfFirstLog = indexOfLastLog - logsPerPage;
    const currentLogs = filteredLogs.slice(indexOfFirstLog, indexOfLastLog);
    const totalPages = Math.ceil(filteredLogs.length / logsPerPage);

    // Convert file to Base64
    const fileToBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = (err) => reject(err);
            reader.readAsDataURL(file);
        });

    const addBase64Attachment = async (file) => {
        const base64 = await fileToBase64(file);
        setAttachments((prev) => [...prev, { name: file.name, base64 }]);

        if (file.type.startsWith("image/") && editorRef.current) {
            const img = document.createElement("img");
            img.src = base64;
            img.style.maxWidth = "200px";
            img.style.borderRadius = "6px";
            img.style.margin = "5px 0";
            editorRef.current.appendChild(img);
            moveCaretToEnd(editorRef.current);
        }
    };

    const handlePaste = (e) => {
        if (e.clipboardData && e.clipboardData.files.length > 0) {
            e.preventDefault();
            addBase64Attachment(e.clipboardData.files[0]);
        }
    };

    const handleFileUpload = (e) => {
        const files = Array.from(e.target.files);
        files.forEach(addBase64Attachment);
    };

    const removeAttachment = (index) => {
        setAttachments((prev) => prev.filter((_, i) => i !== index));
    };

    const addComment = async () => {
        const plainText = editorRef.current?.innerText?.trim() || "";
        if (!plainText || !activeTask) return;

        const payload = {
            text: plainText,
            mentions: mentions.map((m) => m.id),
            attachments, // {name, base64}
        };

        try {
            const res = await fetch(
                `${API_BASE_URL}/api/tasks/${activeTask.id}/comments`,
                {
                    method: "POST",
                    headers: {
                        Authorization: "Bearer " + token,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );

            if (res.ok) {
                const newComment = await res.json();
                setComments((prev) => [...prev, newComment]);
                cancelComment();
            } else {
                console.error("Failed to save comment:", res.statusText);
            }
        } catch (err) {
            console.error("Error saving comment:", err);
        }
    };




    const saveEdit = async (commentId) => {
        const plainTextEdit = editRef.current?.innerText?.trim() || "";
        if (!plainTextEdit) return;
        try {
            const res = await fetch(
                `${API_BASE_URL}/api/tasks/comments/${commentId}`,
                {
                    method: "PUT",
                    headers: {
                        Authorization: "Bearer " + token,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ text: plainTextEdit }),
                }
            );
            if (res.ok) {
                const updated = await res.json();
                setComments((prev) =>
                    prev.map((c) => (c.id === commentId ? updated : c))
                );
                setEditingCommentId(null);
                setEditContent("");
                if (editRef.current) editRef.current.innerHTML = "";
            }
        } catch (err) {
            console.error("Error editing comment:", err);
        }
    };

    const submitReply = (commentId) => {
        if (!replyContent.trim()) return;

        const token = localStorage.getItem("token");

        fetch(`${API_BASE_URL}/api/tasks/comments/${commentId}/replies`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
            },
            body: JSON.stringify({
                text: replyContent,
                author: localStorage.getItem("username") || "Me", // replace with actual username
            }),
        })
            .then(res => res.json())
            .then(newReply => {
                // Add reply to state
                setReplies(prev => [...prev, newReply]);
                setReplyContent("");
                setReplyToCommentId(null);
            })
            .catch(err => console.error(err));
    };

    const deleteComment = async (commentId) => {
        try {
            const res = await fetch(
                `${API_BASE_URL}/api/tasks/comments/${commentId}`,
                {
                    method: "DELETE",
                    headers: { Authorization: "Bearer " + token },
                }
            );
            if (res.ok) {
                setComments((prev) => prev.filter((c) => c.id !== commentId));
            }
        } catch (err) {
            console.error("Error deleting comment:", err);
        }
    };

    const cancelComment = () => {
        if (editorRef.current) editorRef.current.innerHTML = "";
        setAttachments([]);
        setMentions([]);
    };

    const handleEditorInput = (e) => {
        const text = e.target.innerText;
        const lastWord = text.split(/\s/).pop();
        if (lastWord && lastWord.startsWith("@")) {
            const query = lastWord.substring(1).toLowerCase();
            const filtered = mentionableUsers.filter((u) =>
                `${u.firstName} ${u.lastName}`.toLowerCase().includes(query)
            );
            setFilteredUsers(filtered);
            setShowSuggestions(true);
        } else {
            setShowSuggestions(false);
        }
    };

    const addMention = (user) => {
        const fullName = `${user.firstName} ${user.lastName}`;
        const editor = editorRef.current;
        if (!editor) return;

        const sel = window.getSelection();
        sel.removeAllRanges();

        // Restore previous caret position
        if (savedRange) {
            sel.addRange(savedRange);
        }

        if (!sel.rangeCount) return;

        const range = sel.getRangeAt(0);
        const node = range.startContainer;
        let offset = range.startOffset;

        // Remove the last "@word" typed if inside a text node
        if (node.nodeType === Node.TEXT_NODE) {
            const text = node.textContent;
            const words = text.slice(0, offset).split(/\s/);
            const lastWord = words[words.length - 1] || "";

            if (lastWord.startsWith("@")) {
                const newText = words.slice(0, -1).join(" ");
                node.textContent = newText ? newText + " " : "";
                offset = node.textContent.length;
            }
        }







        // Create the mention span
        const span = document.createElement("span");
        span.className = "  me-1 text-dark";
        span.contentEditable = "false";
        span.innerText = fullName;

        // Insert the span at the caret
        range.setStart(node, offset);
        range.setEnd(node, offset);
        range.deleteContents();
        range.insertNode(span);
        range.collapse(false);

        // Add a space after the mention
        const space = document.createTextNode(" ");
        span.after(space);

        // Move caret after the mention
        sel.removeAllRanges();
        const newRange = document.createRange();
        newRange.setStartAfter(space);
        newRange.collapse(true);
        sel.addRange(newRange);

        // Update state and hide suggestions
        setMentions((prev) => [...prev, user]);
        setShowSuggestions(false);

        // Focus back to editor
        editor.focus();

        // Clear saved range
        setSavedRange(null);
    };



    const handleEditInput = () => {
        if (editRef.current) {
            setEditContent(editRef.current.innerText);
        }
    };



    const isImageFile = (fileName) => {
        const lower = fileName.toLowerCase();
        return (
            lower.endsWith(".png") ||
            lower.endsWith(".jpg") ||
            lower.endsWith(".jpeg") ||
            lower.endsWith(".gif") ||
            lower.endsWith(".bmp") ||
            lower.endsWith(".webp")
        );
    };


    if (loading) return <div className="text-center mt-5">Loading...</div>;

    return (

        <>
            {/* Navbar fixed on top */}
            <div className="fixed-top">
                <EmployeeNavbar />
            </div>
            <div className="d-flex flex-column" style={{ minheight: "100vh", paddingTop: "130px" }}>

                <div className="flex-grow-1 d-flex flex-column p-3 scroll-main-content">

                    <div className="d-flex" style={{ height: "100%", overflow: "hidden" }}>
                        {/* ---- SIDEBAR (fixed) ---- */}
                        <aside className="projects-sidebar">
                            <div className="projects-sidebar__inner p-2">
                                <div className="d-flex align-items-center justify-content-between mb-2">
                                    <strong>Overview</strong>
                                    {/* <button className="btn btn-sm btn-light" onClick={() => setSelectedProject("all")}>All</button> */}
                                </div>

                                <div className="list-group">
                                    {/* All Projects entry */}
                                    <button
                                        className={`list-group-item list-group-item-action ${selectedProject === "all" ? "active" : ""}`}
                                        onClick={() => setSelectedProject("all")}
                                    >
                                        📚 Dashboard
                                    </button>

                                    {/* Project items */}
                                    {projects.map((p) => (
                                        <button
                                            key={p.id}
                                            className={`list-group-item list-group-item-action d-flex justify-content-between align-items-center ${String(selectedProject) === String(p.id) ? "active" : ""}`}
                                            onClick={() => setSelectedProject(String(p.id))}
                                            title={p.description || p.name}
                                        >
                                            <span className="text-truncate" style={{ maxWidth: "140px" }}>📁 {p.name}</span>
                                            <small className="text-muted ms-2">{tasks.filter(t => t.project?.id === p.id).length}</small>
                                        </button>
                                    ))}

                                    <button
                                        className="btn btn-sm btn-outline-primary"
                                        onClick={() => navigate("/timesheetgrid", { state: { employeeId } })}

                                    >
                                        ⏱️ Timesheet
                                    </button>
                                </div>
                            </div>
                        </aside>


                    </div>


                

                {activeTask && (
                    <div
                        className="inline-task-details" 
                        onClick={(e) => e.stopPropagation()}
                        role="region"
                        aria-label="Task details panel"
                    >
                        <div
                            className="modal-dialog  modal-xl"
                            role="document"
                        >
                            <div className="modal-content task-modal-emp" style={{
                                maxHeight: "none",
                                overflowY: "auto",
                            }}>

                                <div className="modal-header bg-light d-flex justify-content-between align-items-center">
                                    <div className="task-section mb-0" style={{ paddingRight: "10px" }}>
                                        {editField === "title" ? (
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={editedTask.title || ""}
                                                onChange={(e) =>
                                                    setEditedTask({ ...editedTask, title: e.target.value })
                                                }
                                                onBlur={() => {
                                                    updateTaskField(activeTask.id, "title", editedTask.title);
                                                    setEditField(null);
                                                }}
                                                autoFocus
                                                style={{ fontSize: "1.1rem", fontWeight: "600" }}
                                            />
                                        ) : (
                                            <h5
                                                className="modal-title fw-semibold mb-0"
                                                onClick={() => {
                                                    setEditedTask({ ...activeTask });
                                                    setEditField("title");
                                                }}
                                                style={{ cursor: "pointer" }}
                                                title="Click to edit title"
                                            >
                                                {activeTask.title || (
                                                    <span className="text-muted fst-italic">Click to add title...</span>
                                                )}
                                            </h5>
                                        )}
                                    </div>
                                </div>

                                <div className="modal-body task-modal-emp__body">
                                    <div className="row g-3">
                                        {/* LEFT: Main Task Content */}
                                        <div className="col-md-8 task-modal-emp__main">
                                            <div className="task-section mb-3">
                                                <div className="task-section__header">
                                                    <h6 className="task-section__title mb-0">Description</h6>
                                                </div>

                                                {editField === "description" ? (
                                                    <textarea
                                                        className="form-control mt-2"
                                                        rows={4}
                                                        value={editedTask.description || ""}
                                                        onChange={(e) =>
                                                            setEditedTask({ ...editedTask, description: e.target.value })
                                                        }
                                                        onBlur={() => {
                                                            updateTaskField(activeTask.id, "description", editedTask.description);
                                                            setEditField(null);
                                                        }}
                                                        autoFocus
                                                    />
                                                ) : (
                                                    <div
                                                        className="task-section__body description-text"
                                                        onClick={() => {
                                                            setEditedTask({ ...activeTask });
                                                            setEditField("description");
                                                        }}
                                                    >
                                                        {activeTask.description || (
                                                            <span className="text-muted fst-italic">
                                                                Click to add description...
                                                            </span>
                                                        )}
                                                    </div>
                                                )}
                                            </div>

                                            {/* Worklogs Section */}
                                            <div className="card shadow-none border-0 task-section task-section--worklogs">
                                                <div className="card-body">

                                                    <div className="d-flex align-items-center mb-3" style={{ gap: "10px" }}>
                                                        <h5 className="fw-bold mb-0"> Worklogs</h5>
                                                        <button
                                                            className="btn btn-sm btn-primary mb-0"
                                                            onClick={() => setShowLogForm(!showLogForm)}
                                                        >
                                                            Log Time
                                                        </button>
                                                    </div>

                                                    <div className="row">
                                                        {/* LEFT: Log Form + Worklogs */}
                                                        <div className="col-md-12">
                                                            {showLogForm && (
                                                                <>
                                                                    {/* Dimmed overlay that closes modal on click */}
                                                                    <div
                                                                        className="modal-backdrop fade show"
                                                                        onClick={() => setShowLogForm(false)}
                                                                        style={{ cursor: "pointer" }}
                                                                    ></div>

                                                                    {/* Modal */}
                                                                    <div
                                                                        className="modal show fade d-block"
                                                                        tabIndex="-1"
                                                                        role="dialog"
                                                                        onClick={(e) => e.stopPropagation()} // prevent clicks inside modal from closing it
                                                                    >
                                                                        <div className="modal-dialog modal-dialog-centered modal-md " role="document">
                                                                            <div className="modal-content">
                                                                                <form
                                                                                    onSubmit={(e) => {
                                                                                        e.preventDefault();
                                                                                        saveWorklog();
                                                                                    }}
                                                                                >
                                                                                    {/* Header */}
                                                                                    <div className="modal-header border-bottom bg-light">
                                                                                        <h5 className="modal-title fw-semibold">
                                                                                            <i className="bi bi-clock me-2 text-primary"></i> Log Time
                                                                                        </h5>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn-close"
                                                                                            onClick={() => setShowLogForm(false)}
                                                                                        ></button>
                                                                                    </div>

                                                                                    {/* Body */}
                                                                                    <div className="modal-body">

                                                                                        {/* ✅ Task at top */}
                                                                                        <div className="mb-3 ">
                                                                                            <label className="form-label fw-semibold small text-muted " style={{ width: "450px", textAlign: "left" }}>Task</label>
                                                                                            <div className="input-group">
                                                                                                <span className="input-group-text bg-white">
                                                                                                    <i className="bi bi-clipboard"></i>
                                                                                                </span>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    className="form-control"
                                                                                                    value={activeTask?.title || ""}
                                                                                                    readOnly
                                                                                                />
                                                                                            </div>
                                                                                        </div>

                                                                                        {/* Date + Duration */}
                                                                                        <div className="row g-3 mb-3">
                                                                                            <div className="col-6">
                                                                                                <label className="form-label fw-semibold small text-muted">Date</label>
                                                                                                <input
                                                                                                    type="date"
                                                                                                    className="form-control"
                                                                                                    value={logDate}
                                                                                                    onChange={(e) => {
                                                                                                        setLogDate(e.target.value);
                                                                                                        setSelectedDate(new Date(e.target.value));
                                                                                                    }}
                                                                                                    required
                                                                                                />
                                                                                            </div>
                                                                                            <div className="col-6">
                                                                                                <label className="form-label fw-semibold small text-muted">Duration</label>
                                                                                                <div className="input-group">
                                                                                                    <input
                                                                                                        type="number"
                                                                                                        className="form-control"
                                                                                                        placeholder="0"
                                                                                                        value={logHours}
                                                                                                        onChange={(e) => setLogHours(e.target.value)}
                                                                                                        required
                                                                                                        min="0.5"
                                                                                                        step="0.01"
                                                                                                    />
                                                                                                    <span className="input-group-text">h</span>
                                                                                                </div>
                                                                                                <small className="text-muted">Enter hours spent</small>
                                                                                            </div>
                                                                                        </div>

                                                                                        {/* Billing Type */}
                                                                                        <div className="mb-3">
                                                                                            <label className="form-label fw-semibold small text-muted" style={{ width: "450px", textAlign: "left" }}>Billing Type</label>
                                                                                            <div className="d-flex gap-4 mt-1">
                                                                                                <div className="form-check">
                                                                                                    <input
                                                                                                        className="form-check-input"
                                                                                                        type="radio"
                                                                                                        name="billingType"
                                                                                                        id="billable"
                                                                                                        value="billable"
                                                                                                        checked={billingType === "billable"}
                                                                                                        onChange={(e) => setBillingType(e.target.value)}
                                                                                                    />
                                                                                                    <label className="form-check-label" htmlFor="billable">
                                                                                                        Billable
                                                                                                    </label>
                                                                                                </div>
                                                                                                <div className="form-check">
                                                                                                    <input
                                                                                                        className="form-check-input"
                                                                                                        type="radio"
                                                                                                        name="billingType"
                                                                                                        id="nonBillable"
                                                                                                        value="non-billable"
                                                                                                        checked={billingType === "non-billable"}
                                                                                                        onChange={(e) => setBillingType(e.target.value)}
                                                                                                    />
                                                                                                    <label className="form-check-label" htmlFor="nonBillable">
                                                                                                        Non-Billable
                                                                                                    </label>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>

                                                                                        {/* Description */}
                                                                                        <div className="mb-3">
                                                                                            <label className="form-label fw-semibold small text-muted" style={{ width: "450px", textAlign: "left" }}>Description</label>
                                                                                            <textarea
                                                                                                className="form-control"
                                                                                                rows="3"
                                                                                                placeholder="What did you work on?"
                                                                                                value={logDescription}
                                                                                                onChange={(e) => setLogDescription(e.target.value)}
                                                                                                required
                                                                                            ></textarea>
                                                                                        </div>
                                                                                    </div>

                                                                                    {/* Footer */}
                                                                                    <div className="modal-footer border-top">
                                                                                        <div className="form-check me-auto">
                                                                                            <input
                                                                                                className="form-check-input"
                                                                                                type="checkbox"
                                                                                                id="logAnother"
                                                                                                checked={logAnother}
                                                                                                onChange={(e) => setLogAnother(e.target.checked)}
                                                                                            />
                                                                                            <label className="form-check-label small" htmlFor="logAnother">
                                                                                                Log another
                                                                                            </label>
                                                                                        </div>
                                                                                        <button type="submit" className="btn btn-primary">
                                                                                            Log time
                                                                                        </button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-link text-muted"
                                                                                            onClick={() => setShowLogForm(false)}
                                                                                        >
                                                                                            Cancel
                                                                                        </button>
                                                                                    </div>
                                                                                </form>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )}

                                                            {/* Attachment Gallery */}
                                                            <div className="card shadow-none border-0 mt-3">
                                                                <div className="card-body">
                                                                    <h6 className="fw-semibold mb-3 text-start">
                                                                        All Attachments ({taskAttachments.length})
                                                                    </h6>

                                                                    {taskAttachments.length > 0 ? (
                                                                        <div className="d-flex flex-wrap gap-3">
                                                                            {taskAttachments.map((file, index) => {
                                                                                const isImage = file.name?.match(/\.(jpeg|jpg|png|gif|bmp|webp)$/i);
                                                                                const fileUrl = getDataUrl(file);

                                                                                return (
                                                                                    <div
                                                                                        key={index}
                                                                                        className="position-relative border rounded shadow-sm bg-white"
                                                                                        style={{
                                                                                            width: "130px",
                                                                                            height: "130px",
                                                                                            overflow: "hidden",
                                                                                            cursor: "pointer",
                                                                                            transition: "transform 0.2s ease",
                                                                                        }}
                                                                                        onClick={() => {
                                                                                            if (isImage) {
                                                                                                const images = taskAttachments
                                                                                                    .filter(f => f.name?.match(/\.(jpeg|jpg|png|gif|bmp|webp)$/i))
                                                                                                    .map(f => getDataUrl(f));
                                                                                                setPreviewImages(images);
                                                                                                setCurrentImageIndex(images.indexOf(fileUrl));
                                                                                            } else {
                                                                                                window.open(fileUrl, "_blank");
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        {isImage ? (
                                                                                            <img
                                                                                                src={fileUrl}
                                                                                                alt={file.name}
                                                                                                className="w-100 h-100"
                                                                                                style={{ objectFit: "cover" }}
                                                                                            />
                                                                                        ) : (
                                                                                            <div className="d-flex align-items-center justify-content-center h-100 text-secondary bg-light">
                                                                                                <i className="bi bi-file-earmark-text fs-1"></i>
                                                                                            </div>
                                                                                        )}

                                                                                        <div
                                                                                            className="position-absolute bottom-0 w-100 bg-dark bg-opacity-50 text-white text-truncate small px-1 py-1"
                                                                                            title={file.name}
                                                                                        >
                                                                                            {file.name}
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                        </div>
                                                                    ) : (
                                                                        <p className="text-muted fst-italic">No attachments available for this task.</p>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            {/* 🔍 Image Preview Modal */}
                                                            {previewImages.length > 0 && (
                                                                <div
                                                                    className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                                                                    style={{ background: "rgba(0,0,0,0.8)", zIndex: 1050 }}
                                                                    onClick={() => setPreviewImages([])}
                                                                >
                                                                    <div className="position-relative" onClick={(e) => e.stopPropagation()}>
                                                                        <img
                                                                            src={previewImages[currentImageIndex]}
                                                                            alt="Preview"
                                                                            style={{ maxHeight: "80vh", maxWidth: "80vw", borderRadius: "8px" }}
                                                                        />

                                                                        {/* Previous */}
                                                                        {currentImageIndex > 0 && (
                                                                            <button
                                                                                className="btn btn-dark position-absolute top-50 start-0 translate-middle-y"
                                                                                style={{ opacity: 0.7 }}
                                                                                onClick={() => setCurrentImageIndex(currentImageIndex - 1)}
                                                                            >
                                                                                ‹
                                                                            </button>
                                                                        )}

                                                                        {/* Next */}
                                                                        {currentImageIndex < previewImages.length - 1 && (
                                                                            <button
                                                                                className="btn btn-dark position-absolute top-50 end-0 translate-middle-y"
                                                                                style={{ opacity: 0.7 }}
                                                                                onClick={() => setCurrentImageIndex(currentImageIndex + 1)}
                                                                            >
                                                                                ›
                                                                            </button>
                                                                        )}

                                                                        {/* Close */}
                                                                        <button
                                                                            className="btn btn-danger position-absolute top-0 end-0 m-3"
                                                                            onClick={() => setPreviewImages([])}
                                                                        >
                                                                            ✕
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {/* Worklog list (no filters, no pagination) */}
                                                            {filteredLogs.length > 0 ? (
                                                                <div
                                                                    className="worklog-list-scroll"
                                                                    style={{
                                                                        maxHeight: "300px",   // 👈 adjust height as needed (e.g., 250px–400px)
                                                                        overflowY: "auto",
                                                                        border: "1px solid #eee",
                                                                        borderRadius: "6px",
                                                                    }}
                                                                >
                                                                    <ul className="list-group mt-3 mb-0">
                                                                        {filteredLogs.map((log) => (
                                                                            <li
                                                                                key={log.id}
                                                                                className="list-group-item d-flex justify-content-between align-items-center"
                                                                            >
                                                                                <div>
                                                                                    <div className="fw-normal text-start">
                                                                                        {log.description || "No description"}
                                                                                    </div>
                                                                                    <small className="text-start w-100 d-block">
                                                                                        {new Date(log.date).toLocaleDateString("en-GB")} ·{" "}
                                                                                        {log.billingType === "billable"
                                                                                            ? " Billable"
                                                                                            : " Non-billable"}
                                                                                    </small>
                                                                                </div>

                                                                                <div className="d-flex align-items-center gap-2">
                                                                                    <span>{log.hours}h</span>

                                                                                    {/* ✏️ Edit button */}
                                                                                    <span
                                                                                        style={{ cursor: "pointer", fontSize: "18px" }}
                                                                                        title="Edit Worklog"
                                                                                        onClick={() => editWorklog(log)}
                                                                                    >
                                                                                        <svg
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                            width="16"
                                                                                            height="16"
                                                                                            fill="black"
                                                                                            className="bi bi-pencil"
                                                                                            viewBox="0 0 16 16"
                                                                                        >
                                                                                            <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 
                                              10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 
                                              0 1-.65-.65l2-5a.5.5 0 0 1 
                                              .11-.168zM11.207 2.5 13.5 4.793 
                                              14.793 3.5 12.5 1.207zm1.586 3L10.5 
                                              3.207 4 9.707V10h.5a.5.5 0 0 1 
                                              .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293z" />
                                                                                        </svg>
                                                                                    </span>

                                                                                    {/* 🗑 Delete button */}
                                                                                    <span
                                                                                        style={{ cursor: "pointer", color: "red", fontSize: "18px" }}
                                                                                        title="Delete Worklog"
                                                                                        onClick={() => deleteWorklog(log.id)}
                                                                                    >
                                                                                        <svg
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                            width="16"
                                                                                            height="16"
                                                                                            fill="red"
                                                                                            className="bi bi-trash"
                                                                                            viewBox="0 0 16 16"
                                                                                        >
                                                                                            <path
                                                                                                d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 
                                            0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 
                                            .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 
                                            .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 
                                            0 0 0 1 0z"
                                                                                            />
                                                                                            <path
                                                                                                d="M14.5 3a1 1 0 0 1-1 
                                          1H13v9a2 2 0 0 1-2 
                                          2H5a2 2 0 0 1-2-2V4h-.5a1 
                                          1 0 0 1-1-1V2a1 1 0 0 
                                          1 1-1H6a1 1 0 0 1 1-1h2a1 
                                          1 0 0 1 1 1h3.5a1 1 0 0 1 
                                          1 1zM4.118 4 4 4.059V13a1 
                                          1 0 0 0 1 1h6a1 1 0 0 0 
                                          1-1V4.059L11.882 4zM2.5 
                                          3h11V2h-11z"
                                                                                            />
                                                                                        </svg>
                                                                                    </span>
                                                                                </div>
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                </div>
                                                            ) : (
                                                                <p className="text-muted mt-3">No worklogs available.</p>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* New Comment */}
                                            <div className="card shadow-none border-0 task-section task-section--comments">
                                                <div className="card-body col-md-12">

                                                    {/* Toolbar */}
                                                    <div
                                                        className="border-bottom pb-2 mb-2 sticky-top bg-white d-flex gap-2 flex-wrap"
                                                        style={{ top: 0, zIndex: 5 }}
                                                    >
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-light"
                                                            title="Bold"
                                                            onClick={() => document.execCommand("bold")}
                                                        >
                                                            <b>B</b>
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-light"
                                                            title="Italic"
                                                            onClick={() => document.execCommand("italic")}
                                                        >
                                                            <i>I</i>
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-light"
                                                            title="Underline"
                                                            onClick={() => document.execCommand("underline")}
                                                        >
                                                            <u>U</u>
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-light"
                                                            title="List"
                                                            onClick={() => document.execCommand("insertUnorderedList")}
                                                        >
                                                            • List
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-light"
                                                            title="Quote"
                                                            onClick={() =>
                                                                document.execCommand("formatBlock", false, "blockquote")
                                                            }
                                                        >
                                                            ❝
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-light"
                                                            title="Insert Link"
                                                            onClick={() => {
                                                                const url = prompt("Enter link URL:");
                                                                if (url) document.execCommand("createLink", false, url);
                                                            }}
                                                        >
                                                            🔗
                                                        </button>
                                                    </div>

                                                    {/* Editable area */}
                                                    <div style={{ display: "flex", flexDirection: "column", position: "relative", border: "1px solid #ddd", borderRadius: "6px", background: "#fff", minHeight: "100px", padding: "10px" }}>

                                                        {/* Editable area - unchanged */}
                                                        <div
                                                            ref={editorRef}
                                                            className="mb-2"
                                                            contentEditable
                                                            suppressContentEditableWarning
                                                            onInput={handleEditorInput}
                                                            onKeyUp={saveCaret}
                                                            onClick={saveCaret}
                                                            onPaste={handlePaste}
                                                            placeholder="Write a comment..."
                                                            style={{
                                                                minHeight: "100px",
                                                                outline: "none",
                                                                textAlign: "left",
                                                                fontSize: "14px",
                                                                lineHeight: "1.5",
                                                                fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
                                                                overflowY: "auto",
                                                                whiteSpace: "pre-wrap",
                                                                wordWrap: "break-word",
                                                            }}
                                                        ></div>

                                                        {/* Horizontal list inside the editor at the bottom */}
                                                        <div
                                                            className="d-flex gap-2 overflow-auto mt-2"
                                                            style={{
                                                                padding: "6px",
                                                                borderTop: "1px solid #ddd",
                                                                maxWidth: "100%",
                                                                background: "#f8f9fa",
                                                            }}
                                                        >
                                                            {mentionableUsers.map((u) => {
                                                                const photoUrl = u.photoPath
                                                                    ? `${API_BASE_URL}/uploads/${u.photoPath}`
                                                                    : null;
                                                                return (
                                                                    <div
                                                                        key={u.id}
                                                                        className="d-flex align-items-center px-2 py-1 rounded"
                                                                        style={{
                                                                            background: "#e9ecef",
                                                                            cursor: "pointer",
                                                                            whiteSpace: "nowrap",
                                                                        }}
                                                                        onClick={() => addMention(u)}
                                                                    >
                                                                        {/* Avatar / Photo */}
                                                                        <div
                                                                            className="rounded-circle me-1 d-flex justify-content-center align-items-center"
                                                                            style={{
                                                                                width: "24px",
                                                                                height: "24px",
                                                                                overflow: "hidden",
                                                                                flexShrink: 0,
                                                                                background: photoUrl ? "transparent" : "#0d6efd",
                                                                                color: "#fff",
                                                                                fontSize: "12px",
                                                                                fontWeight: "600",
                                                                            }}
                                                                        >
                                                                            {photoUrl ? (
                                                                                <img
                                                                                    src={photoUrl}
                                                                                    alt={`${u.firstName} ${u.lastName}`}
                                                                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                                                    onError={(e) => {
                                                                                        e.currentTarget.onerror = null;
                                                                                        e.currentTarget.src = "/images/avatar-placeholder.png";
                                                                                    }}
                                                                                />
                                                                            ) : (
                                                                                u.firstName.charAt(0).toUpperCase()
                                                                            )}
                                                                        </div>

                                                                        {/* Name */}
                                                                        <span style={{ fontSize: "13px", fontWeight: "500" }}>
                                                                            {u.firstName} {u.lastName}
                                                                        </span>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>

                                                    </div>

                                                    {/* Mention suggestions */}
                                                    {showSuggestions && filteredUsers.length > 0 && editorRef.current && (
                                                        <div
                                                            className="position-absolute"
                                                            style={{
                                                                zIndex: 1000,
                                                                top:
                                                                    (editorRef.current?.offsetTop || 0) +
                                                                    (editorRef.current?.offsetHeight || 0) +
                                                                    4,
                                                                left: editorRef.current?.offsetLeft || 0,
                                                            }}
                                                        >
                                                            <div
                                                                className="shadow-lg border bg-white rounded-3 overflow-hidden"
                                                                style={{
                                                                    width: "280px",
                                                                    maxHeight: "250px",
                                                                    overflowY: "auto",
                                                                    boxShadow: "0 6px 20px rgba(0, 0, 0, 0.15)",
                                                                    animation: "fadeInUp 0.2s ease-out",
                                                                }}
                                                            >
                                                                {filteredUsers.map((u, i) => {
                                                                    const photoUrl = u.photoPath
                                                                        ? `${API_BASE_URL}/uploads/${u.photoPath}`
                                                                        : null;

                                                                    return (
                                                                        <button
                                                                            key={u.id}
                                                                            type="button"
                                                                            onClick={() => addMention(u)}
                                                                            className="d-flex align-items-center w-100 px-3 py-2 border-0 text-start bg-transparent"
                                                                            style={{
                                                                                cursor: "pointer",
                                                                                transition: "all 0.15s ease-in-out",
                                                                                borderBottom:
                                                                                    i < filteredUsers.length - 1 ? "1px solid #f0f0f0" : "none",
                                                                            }}
                                                                            onMouseEnter={(e) => {
                                                                                e.currentTarget.style.background = "#f8f9ff";
                                                                                e.currentTarget.style.transform = "translateX(2px)";
                                                                            }}
                                                                            onMouseLeave={(e) => {
                                                                                e.currentTarget.style.background = "transparent";
                                                                                e.currentTarget.style.transform = "translateX(0)";
                                                                            }}
                                                                        >
                                                                            {/* Avatar / Photo */}
                                                                            <div
                                                                                className="rounded-circle d-flex justify-content-center align-items-center me-3"
                                                                                style={{
                                                                                    width: "34px",
                                                                                    height: "34px",
                                                                                    flexShrink: 0,
                                                                                    overflow: "hidden",
                                                                                    background: photoUrl
                                                                                        ? "transparent"
                                                                                        : "linear-gradient(135deg, #0d6efd 0%, #5a9eff 100%)",
                                                                                    boxShadow: "0 1px 3px rgba(0,0,0,0.15)",
                                                                                    fontWeight: "600",
                                                                                    fontSize: "15px",
                                                                                    color: "#fff",
                                                                                }}
                                                                            >
                                                                                {photoUrl ? (
                                                                                    <img
                                                                                        src={photoUrl}
                                                                                        alt={`${u.firstName} ${u.lastName}`}
                                                                                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                                                        onError={(e) => {
                                                                                            e.currentTarget.onerror = null;
                                                                                            e.currentTarget.src = "/images/avatar-placeholder.png";
                                                                                        }}
                                                                                    />
                                                                                ) : (
                                                                                    u.firstName.charAt(0).toUpperCase()
                                                                                )}
                                                                            </div>

                                                                            {/* User Info */}
                                                                            <div className="flex-grow-1">
                                                                                <div style={{ fontSize: "14px", fontWeight: "500", color: "#212529" }}>
                                                                                    {u.firstName} {u.lastName}
                                                                                </div>
                                                                            </div>
                                                                        </button>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>
                                                    )}

                                                    {/* Attachments */}
                                                    {attachments.length > 0 && (
                                                        <div className="mb-2">
                                                            {attachments.map((f, i) => (
                                                                <span
                                                                    key={i}
                                                                    className="badge bg-light text-dark me-2 d-inline-flex align-items-center"
                                                                    style={{
                                                                        fontSize: "13px",
                                                                        padding: "6px 8px",
                                                                        border: "1px solid #ddd",
                                                                        borderRadius: "12px",
                                                                        background: "#f8f9fa",
                                                                    }}
                                                                >
                                                                    📎 {f.name}
                                                                    <button
                                                                        className="btn btn-sm btn-link text-danger p-0 ms-1"
                                                                        onClick={() => removeAttachment(i)}
                                                                        style={{ fontSize: "12px" }}
                                                                    >
                                                                        ❌
                                                                    </button>
                                                                </span>
                                                            ))}
                                                        </div>
                                                    )}

                                                    {/* Action buttons */}
                                                    <div className="d-flex gap-2">
                                                        <button className="btn btn-primary btn-sm" onClick={addComment}>
                                                            Add Comment
                                                        </button>
                                                        <button
                                                            className="btn btn-outline-secondary btn-sm"
                                                            onClick={cancelComment}
                                                        >
                                                            Cancel
                                                        </button>
                                                        <label className="btn btn-sm btn-outline-secondary mb-0">
                                                            📎 Attach
                                                            <input type="file" multiple onChange={handleFileUpload} hidden />
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* 💬 Comments Section */}
                                            <div className="mt-4 col-md-12">
                                                <h5 className="mb-3"> Comments</h5>

                                                <div
                                                    className="comments-container"
                                                    style={{
                                                        maxHeight: "350px",     // 👈 scrollable height limit
                                                        overflowY: "auto",
                                                        paddingRight: "8px",
                                                        border: "1px solid #eee",
                                                        borderRadius: "8px",
                                                        background: "#fafafa",
                                                    }}
                                                >
                                                    {comments.length > 0 ? (
                                                        <div className="d-flex flex-column gap-3 p-2">
                                                            {comments.map((c) => {
                                                                let attachmentsArray = [];
                                                                try {
                                                                    attachmentsArray =
                                                                        typeof c.attachments === "string"
                                                                            ? JSON.parse(c.attachments)
                                                                            : c.attachments;
                                                                } catch (err) {
                                                                    console.error("Invalid attachments JSON", err);
                                                                }

                                                                const commentReplies = c.replies || [];

                                                                return (
                                                                    <div
                                                                        key={c.id}
                                                                        className="p-3 shadow-sm rounded-3"
                                                                        style={{
                                                                            background: "#fff",
                                                                            position: "relative",
                                                                            display: "flex",
                                                                            gap: "12px",
                                                                            alignItems: "flex-start",
                                                                            borderLeft: "4px solid #0d6efd",
                                                                        }}
                                                                    >
                                                                        {/* Avatar */}
                                                                        <div
                                                                            className="rounded-circle d-flex justify-content-center align-items-center text-white flex-shrink-0"
                                                                            style={{
                                                                                width: "42px",
                                                                                height: "42px",
                                                                                background: "#0d6efd",
                                                                                fontSize: "16px",
                                                                                fontWeight: "600",
                                                                            }}
                                                                        >
                                                                            {c.author?.charAt(0).toUpperCase()}
                                                                        </div>

                                                                        {/* Comment Content */}
                                                                        <div className="flex-grow-1">
                                                                            <div className="d-flex justify-content-between align-items-center mb-1">
                                                                                <strong style={{ fontSize: "14.5px" }}>{c.author}</strong>
                                                                                <small className="text-muted" style={{ fontSize: "12px" }}>
                                                                                    {new Date(c.createdAt).toLocaleString()}
                                                                                </small>
                                                                            </div>

                                                                            {/* Edit Mode */}
                                                                            {editingCommentId === c.id ? (
                                                                                <div>
                                                                                    <div
                                                                                        ref={editRef}
                                                                                        contentEditable
                                                                                        suppressContentEditableWarning
                                                                                        onInput={handleEditInput}
                                                                                        style={{
                                                                                            minHeight: "60px",
                                                                                            border: "1px solid #ddd",
                                                                                            padding: "8px",
                                                                                            borderRadius: "6px",
                                                                                            marginBottom: "4px",
                                                                                            fontSize: "14px",
                                                                                        }}
                                                                                    >
                                                                                        {editContent}
                                                                                    </div>
                                                                                    <div className="d-flex gap-2 mb-2">
                                                                                        <button
                                                                                            className="btn btn-sm btn-primary"
                                                                                            onClick={() => saveEdit(c.id)}
                                                                                        >
                                                                                            Save
                                                                                        </button>
                                                                                        <button
                                                                                            className="btn btn-sm btn-light"
                                                                                            onClick={() => setEditingCommentId(null)}
                                                                                        >
                                                                                            Cancel
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            ) : (
                                                                                <p style={{ whiteSpace: "pre-wrap", fontSize: "14px" }}>
                                                                                    {c.text}
                                                                                </p>
                                                                            )}

                                                                            {/* Attachments */}
                                                                            <div className="d-flex flex-wrap gap-2 mb-2">
                                                                                {attachmentsArray.map((file, idx) => {
                                                                                    if (file.base64 && isImageFile(file.name)) {
                                                                                        return (
                                                                                            <img
                                                                                                key={idx}
                                                                                                src={file.base64}
                                                                                                alt={file.name}
                                                                                                style={{
                                                                                                    width: "80px",
                                                                                                    height: "80px",
                                                                                                    borderRadius: "8px",
                                                                                                    objectFit: "cover",
                                                                                                    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                                                                                                    cursor: "pointer",
                                                                                                }}
                                                                                                onClick={() => {
                                                                                                    const images = attachmentsArray
                                                                                                        .filter(f => f.base64 && isImageFile(f.name))
                                                                                                        .map(f => f.base64);
                                                                                                    setPreviewImages(images);
                                                                                                    setCurrentImageIndex(images.indexOf(file.base64));
                                                                                                }}
                                                                                            />
                                                                                        );
                                                                                    } else {
                                                                                        return (
                                                                                            <span
                                                                                                key={idx}
                                                                                                className="badge bg-light text-dark p-2"
                                                                                                style={{ fontSize: "13px", borderRadius: "8px", cursor: "pointer" }}
                                                                                                title={file.name}
                                                                                            >
                                                                                                📎 {file.name}
                                                                                            </span>
                                                                                        );
                                                                                    }
                                                                                })}
                                                                            </div>

                                                                            {previewImages.length > 0 && (
                                                                                <div
                                                                                    className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                                                                                    style={{ background: "rgba(0,0,0,0.7)", zIndex: 1050 }}
                                                                                    onClick={() => setPreviewImages([])}
                                                                                >
                                                                                    <div className="position-relative" onClick={(e) => e.stopPropagation()}>
                                                                                        {/* Current Image */}
                                                                                        <img
                                                                                            src={previewImages[currentImageIndex]}
                                                                                            alt="Preview"
                                                                                            style={{ maxHeight: "80vh", maxWidth: "80vw", borderRadius: "8px" }}
                                                                                        />

                                                                                        {/* Previous Button */}
                                                                                        {currentImageIndex > 0 && (
                                                                                            <button
                                                                                                className="btn btn-dark position-absolute top-50 start-0 translate-middle-y"
                                                                                                style={{ opacity: 0.7 }}
                                                                                                onClick={() => setCurrentImageIndex(currentImageIndex - 1)}
                                                                                            >
                                                                                                ‹
                                                                                            </button>
                                                                                        )}

                                                                                        {/* Next Button */}
                                                                                        {currentImageIndex < previewImages.length - 1 && (
                                                                                            <button
                                                                                                className="btn btn-dark position-absolute top-50 end-0 translate-middle-y"
                                                                                                style={{ opacity: 0.7 }}
                                                                                                onClick={() => setCurrentImageIndex(currentImageIndex + 1)}
                                                                                            >
                                                                                                ›
                                                                                            </button>
                                                                                        )}

                                                                                        {/* Close Button */}
                                                                                        <button
                                                                                            className="btn btn-danger position-absolute top-0 end-0 m-2"
                                                                                            onClick={() => setPreviewImages([])}
                                                                                        >
                                                                                            ✕
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            )}

                                                                            {/* Actions */}
                                                                            <div className="d-flex gap-3 mb-2">
                                                                                <span
                                                                                    className="text-primary"
                                                                                    style={{ cursor: "pointer", fontSize: "13px" }}
                                                                                    onClick={() => {
                                                                                        setReplyToCommentId(c.id);
                                                                                        setReplyContent("");
                                                                                    }}
                                                                                >
                                                                                    💬 Reply
                                                                                </span>
                                                                                <span
                                                                                    className="text-primary"
                                                                                    style={{ cursor: "pointer", fontSize: "13px" }}
                                                                                    onClick={() => {
                                                                                        setEditingCommentId(c.id);
                                                                                        setEditContent(c.text);
                                                                                        setTimeout(() => {
                                                                                            if (editRef.current) {
                                                                                                editRef.current.innerText = c.text || "";
                                                                                                moveCaretToEnd(editRef.current);
                                                                                                editRef.current.focus();
                                                                                            }
                                                                                        }, 150);
                                                                                    }}
                                                                                >
                                                                                    ✏️ Edit
                                                                                </span>
                                                                                <span
                                                                                    className="text-danger"
                                                                                    style={{ cursor: "pointer", fontSize: "13px" }}
                                                                                    onClick={() => deleteComment(c.id)}
                                                                                >
                                                                                    🗑 Delete
                                                                                </span>
                                                                            </div>

                                                                            {/* Reply Input */}
                                                                            {replyToCommentId === c.id && (
                                                                                <div className="d-flex flex-column mb-2">
                                                                                    <textarea
                                                                                        className="form-control mb-1"
                                                                                        placeholder="Write a reply..."
                                                                                        value={replyContent}
                                                                                        onChange={(e) => setReplyContent(e.target.value)}
                                                                                        rows={2}
                                                                                    />
                                                                                    <div className="d-flex gap-2">
                                                                                        <button
                                                                                            className="btn btn-sm btn-primary"
                                                                                            onClick={() => submitReply(c.id)}
                                                                                        >
                                                                                            Reply
                                                                                        </button>
                                                                                        <button
                                                                                            className="btn btn-sm btn-light"
                                                                                            onClick={() => setReplyToCommentId(null)}
                                                                                        >
                                                                                            Cancel
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            )}

                                                                            {/* Replies */}
                                                                            {commentReplies.length > 0 && (
                                                                                <div className="ms-4 mt-2 d-flex flex-column gap-2">
                                                                                    {commentReplies.map((r) => (
                                                                                        <div
                                                                                            key={r.id}
                                                                                            className="p-2 rounded-2"
                                                                                            style={{ background: "#f8f9fa" }}
                                                                                        >
                                                                                            <strong>{r.author}</strong>: {r.text}
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    ) : (
                                                        <p className="text-muted p-2">No comments yet.</p>
                                                    )}
                                                </div>
                                            </div>

                                        </div>

                                        {/* ✅ RIGHT: Sidebar Info */}
                                        <div className="col-md-4 task-modal-emp__sidebar">
                                            <div
                                                className="task-modal-emp__sidebar-card"
                                            >
                                                {/* Header */}
                                                <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                                                    <h6 className="fw-bold mb-0">
                                                        <i className="bi bi-info-circle me-2 text-primary"></i>
                                                        Task Details
                                                    </h6>
                                                    {/* Status */}
                                                    <div>
                                                        {editField === "status" ? (
                                                            <select
                                                                className="form-select form-select-sm"
                                                                style={{ width: "140px" }}
                                                                value={activeTask.status}
                                                                onChange={(e) =>
                                                                    setEditedTask({ ...activeTask, status: e.target.value })
                                                                }
                                                                onBlur={() => {
                                                                    updateTaskField(activeTask.id, "status", editedTask.status);
                                                                    setEditField(null);
                                                                }}
                                                                autoFocus
                                                            >
                                                                <option value="PENDING">To Do</option>
                                                                <option value="IN_PROGRESS">In Progress</option>
                                                                <option value="REVIEW">Review</option>
                                                                <option value="REAY TO TEST">Ready to Test</option>
                                                                <option value="IN TESTING">In Testing</option>
                                                                <option value="COMPLETED">Completed</option>
                                                            </select>
                                                        ) : (
                                                            <span
                                                                className={`badge ${getStatusBadge(activeTask.status)}`}
                                                                style={{ cursor: "pointer" }}
                                                                onClick={() => setEditField("status")}
                                                            >
                                                                {activeTask.status.replace("_", " ")}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>

                                                {/* 🧩 Details Table */}
                                                <div className="table-responsive">
                                                    <table className="table table-borderless align-middle mb-0">
                                                        <tbody>
                                                            {/* Task ID */}
                                                            <tr>
                                                                <th className="fw-semibold " style={{ width: "45%" }}> Task ID</th>
                                                                <td className="fw-normal text-start ">{activeTask.taskCode || ""}</td>
                                                            </tr>

                                                            {/* Project */}
                                                            <tr>
                                                                <th className="fw-semibold">Project</th>
                                                                <td className="fw-normal text-start ">{activeTask.project ? activeTask.project.name : "-"}</td>
                                                            </tr>

                                                            {/* Due Date */}
                                                            <tr>
                                                                <th className="fw-semibold"> Due Date</th>
                                                                <td className="fw-normal text-start ">
                                                                    {editField === "dueDate" ? (
                                                                        <input
                                                                            type="date"
                                                                            className="form-control form-control-sm"
                                                                            value={
                                                                                editedTask?.dueDate
                                                                                    ? new Date(editedTask.dueDate).toISOString().split("T")[0]
                                                                                    : ""
                                                                            }
                                                                            onChange={(e) =>
                                                                                setEditedTask(prev => ({ ...(prev || activeTask || {}), dueDate: e.target.value }))
                                                                            }
                                                                            onBlur={() => {
                                                                                if (!activeTask) {
                                                                                    setEditField(null);
                                                                                    return;
                                                                                }
                                                                                const newDate = editedTask?.dueDate ?? "";
                                                                                const activeDate = activeTask?.dueDate
                                                                                    ? new Date(activeTask.dueDate).toISOString().split("T")[0]
                                                                                    : "";

                                                                                if (newDate !== activeDate) {
                                                                                    updateTaskField(activeTask.id, "dueDate", newDate);
                                                                                }

                                                                                setEditField(null);
                                                                            }}
                                                                            autoFocus
                                                                        />
                                                                    ) : (
                                                                        <span
                                                                            style={{ cursor: "pointer" }}
                                                                            onClick={() => {
                                                                                setEditedTask(activeTask ? { ...activeTask } : {});
                                                                                setEditField("dueDate");
                                                                            }}
                                                                        >
                                                                            {activeTask?.dueDate
                                                                                ? new Date(activeTask.dueDate).toLocaleDateString("en-GB")
                                                                                : "—"}
                                                                        </span>
                                                                    )}
                                                                </td>
                                                            </tr>

                                                            {/* Priority */}
                                                            <tr>
                                                                <th className="fw-semibold"> Priority</th>
                                                                <td className="fw-normal text-start ">
                                                                    {editField === "priority" ? (
                                                                        <select
                                                                            className="form-select form-select-sm"
                                                                            value={activeTask.priority || ""}
                                                                            onChange={(e) =>
                                                                                setEditedTask({ ...activeTask, priority: e.target.value })
                                                                            }
                                                                            onBlur={() => {
                                                                                updateTaskField(activeTask.id, "priority", editedTask.priority);
                                                                                setEditField(null);
                                                                            }}
                                                                            autoFocus
                                                                        >
                                                                            <option value="LOW">Low</option>
                                                                            <option value="MEDIUM">Medium</option>
                                                                            <option value="HIGH">High</option>
                                                                        </select>
                                                                    ) : (
                                                                        <span
                                                                            className={`badge ${activeTask.priority === "HIGH"
                                                                                ? "bg-danger"
                                                                                : activeTask.priority === "MEDIUM"
                                                                                    ? "bg-warning text-dark"
                                                                                    : "bg-secondary"
                                                                                }`}
                                                                            style={{ cursor: "pointer" }}
                                                                            onClick={() => setEditField("priority")}
                                                                        >
                                                                            {activeTask.priority || "Not set"}
                                                                        </span>
                                                                    )}
                                                                </td>
                                                            </tr>

                                                            {/* Task Type */}
                                                            <tr>
                                                                <th className="fw-semibold"> Task Type</th>
                                                                <td className="fw-normal text-start ">
                                                                    {editField === "taskType" ? (
                                                                        <select
                                                                            className="form-select form-select-sm"
                                                                            value={activeTask.taskType || ""}
                                                                            onChange={(e) =>
                                                                                setEditedTask({ ...activeTask, taskType: e.target.value })
                                                                            }
                                                                            onBlur={() => {
                                                                                updateTaskField(activeTask.id, "taskType", editedTask.taskType);
                                                                                setEditField(null);
                                                                            }}
                                                                            autoFocus
                                                                        >
                                                                            <option value="">Select</option>
                                                                            <option value="Bug">Bug</option>
                                                                            <option value="Feature">Feature</option>
                                                                            <option value="Improvement">Improvement</option>
                                                                            <option value="Research">Research</option>
                                                                            <option value="Documentation">Documentation</option>
                                                                        </select>
                                                                    ) : (
                                                                        <span
                                                                            onClick={() => setEditField("taskType")}
                                                                            style={{ cursor: "pointer" }}
                                                                        >
                                                                            {activeTask.taskType || "Click to select"}
                                                                        </span>
                                                                    )}
                                                                </td>
                                                            </tr>

                                                            {/* Team */}
                                                            <tr>
                                                                <th className="fw-semibold"> Team</th>
                                                                <td className="fw-normal text-start ">
                                                                    {editField === "team" ? (
                                                                        <select
                                                                            className="form-select form-select-sm"
                                                                            value={activeTask.team?.id || ""}
                                                                            onChange={(e) => {
                                                                                const selectedTeam = teams.find(
                                                                                    (t) => t.id === parseInt(e.target.value)
                                                                                );
                                                                                setEditedTask({ ...activeTask, team: selectedTeam });
                                                                            }}
                                                                            onBlur={() => {
                                                                                updateTaskField(activeTask.id, "team", editedTask.team);
                                                                                setEditField(null);
                                                                            }}
                                                                            autoFocus
                                                                        >
                                                                            <option value="">Select Team</option>
                                                                            {teams.map((team) => (
                                                                                <option key={team.id} value={team.id}>
                                                                                    {team.name}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                    ) : (
                                                                        <span
                                                                            style={{ cursor: "pointer" }}
                                                                            onClick={() => setEditField("team")}
                                                                        >
                                                                            {activeTask.team ? activeTask.team.name : "Click to select"}
                                                                        </span>
                                                                    )}
                                                                </td>
                                                            </tr>

                                                            {/* Estimated Time */}
                                                            <tr>
                                                                <th className="fw-semibold">Estimated Time</th>
                                                                <td className="fw-normal text-start">
                                                                    {editField === "estimatedTime" ? (
                                                                        <input
                                                                            type="number"
                                                                            className="form-control form-control-sm"
                                                                            value={editedTask.estimatedTime || ""}
                                                                            onChange={(e) =>
                                                                                setEditedTask({ ...editedTask, estimatedTime: e.target.value })
                                                                            }
                                                                            onBlur={() => {
                                                                                updateTaskField(activeTask.id, "estimatedTime", editedTask.estimatedTime);
                                                                                setEditField(null);
                                                                            }}
                                                                            autoFocus
                                                                        />
                                                                    ) : (
                                                                        <span
                                                                            style={{ cursor: "pointer" }}
                                                                            onClick={() => {
                                                                                setEditedTask({ ...activeTask });
                                                                                setEditField("estimatedTime");
                                                                            }}
                                                                        >
                                                                            {activeTask.estimatedTime || 0} hr
                                                                        </span>
                                                                    )}
                                                                </td>
                                                            </tr>

                                                            {/* Total Logged Time */}
                                                            <tr>
                                                                <th className="fw-semibold"> Total Time</th>
                                                                <td className="fw-normal text-start ">{activeTask.totalTime || 0} hr</td>
                                                            </tr>

                                                            {/* Assignee */}
                                                            <tr>
                                                                <th className="fw-semibold"> Assignee</th>
                                                                <td>
                                                                    {editField === "assignee" ? (
                                                                        <select
                                                                            className="form-select form-select-sm"
                                                                            value={activeTask.assignedTo?.id || ""}
                                                                            onChange={(e) => {
                                                                                const selectedId = e.target.value;
                                                                                setEditedTask({
                                                                                    ...activeTask,
                                                                                    assignedTo: employees.find(
                                                                                        (emp) => emp.id === Number(selectedId)
                                                                                    ),
                                                                                });
                                                                                updateTaskField(activeTask.id, "employeeId", selectedId);
                                                                                setEditField(null);
                                                                            }}
                                                                            onBlur={() => setEditField(null)}
                                                                            autoFocus
                                                                        >
                                                                            <option value="">Select Employee</option>
                                                                            {employees.map((emp) => (
                                                                                <option key={emp.id} value={emp.id}>
                                                                                    {emp.firstName} {emp.lastName}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                    ) : activeTask.assignedTo ? (
                                                                        <div
                                                                            className="d-flex align-items-center gap-2"
                                                                            style={{ cursor: "pointer" }}
                                                                            onClick={() => setEditField("assignee")}
                                                                        >
                                                                            <img
                                                                                src={
                                                                                    activeTask.assignedTo.photoPath
                                                                                        ? `/uploads/${activeTask.assignedTo.photoPath}`
                                                                                        : "/default-avatar.png"
                                                                                }
                                                                                alt="Assignee"
                                                                                className="rounded-circle border border-2 border-white"
                                                                                style={{ width: "26px", height: "26px", objectFit: "cover" }}
                                                                            />
                                                                            <span className="fw-normal">
                                                                                {activeTask.assignedTo.firstName}{" "}
                                                                                {activeTask.assignedTo.lastName}
                                                                            </span>
                                                                        </div>
                                                                    ) : (
                                                                        <span
                                                                            className="fw-normal text-start "
                                                                            style={{ cursor: "pointer" }}
                                                                            onClick={() => setEditField("assignee")}
                                                                        >
                                                                            Unassigned
                                                                        </span>
                                                                    )}
                                                                </td>
                                                            </tr>

                                                            {/* Reporter */}
                                                            <tr>
                                                                <th className="fw-semibold"> Reporter</th>
                                                                <td>
                                                                    {activeTask.reporter ? (
                                                                        <div className="d-flex align-items-center gap-2">
                                                                            <img
                                                                                src={
                                                                                    activeTask.reporter.photoPath
                                                                                        ? `/uploads/${activeTask.reporter.photoPath}`
                                                                                        : "/default-avatar.png"
                                                                                }
                                                                                alt="Reporter"
                                                                                className="rounded-circle border border-2 border-white"
                                                                                style={{ width: "26px", height: "26px", objectFit: "cover" }}
                                                                            />
                                                                            <span className="fw-normal text-start">
                                                                                {activeTask.reporter.firstName} {activeTask.reporter.lastName}
                                                                            </span>
                                                                        </div>
                                                                    ) : (
                                                                        <span className="fw-normal text-start ">Unassigned</span>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    {/* END ROW */}
                                </div>
                                {/* END MODAL BODY */}
                            </div>
                            {/*  END MODAL CONTENT */}
                        </div>
                        {/*  END DIALOG wrapper */}
                    </div>
                )}



            </div>
            </div>



        </>
    );
};

export default EmployeeProjectsPage;
